import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {autocompleteEvkOption, EvkFormComponentBase, EvkOption} from '@evomatik/evk-common';
import {FormBuilder, Validators} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {map, startWith} from "rxjs/operators";
import { CatalogosService } from '../../../../../../../expediente/services/catalogos.service';
import { filterOptionsv2 } from '../../../../../utils/functions.utils';

@Component({
    selector: 'diligencia-asignacion-form',
    templateUrl: './diligencia-asignacion-form.component.html',
    styleUrls: ['./diligencia-asignacion-form.component.scss']
})
export class DiligenciaAsignacionFormComponent extends EvkFormComponentBase<any> implements OnInit {

    organizacionFilterOption$: Observable<EvkOption[]>;
    organizacionOption: EvkOption[] = [];

    usuarioFilterOption$: Observable<EvkOption[]>;
    usuarioOption: EvkOption[] = [];

    haveConfigAsignaciones = true;

    @Input()
    idDiligenciaConfig: string;

    @Input()
    labelInput: string;

    catalogosCargados: EventEmitter<boolean> = new EventEmitter();

    isTitularMasc: boolean;
    roles: any;

    constructor(fb: FormBuilder, public catalogoService: CatalogosService) {
        super(fb);
    }

    get formBuild() {
        return this.fb.group({
            unidadDestino: ['', [autocompleteEvkOption, Validators.required]],
            usuarioDestino: ['', [autocompleteEvkOption, Validators.required]],
            usuarioOrigen: ['', [autocompleteEvkOption, Validators.required]],
        });
    }

    ngOnInit() {
        super.ngOnInit();
        const idUnidad = localStorage.getItem('unidadId');
        const unidad = localStorage.getItem('unidad');

        const usuarioOrigenOption: EvkOption = {
            value: localStorage.getItem('username'),
            label: localStorage.getItem('nombreCompleto'),
            disabled: true
        };

        this.form.controls.usuarioOrigen.setValue(usuarioOrigenOption);
        this.catalogoService.getOrganizacionesByIdDiligencia(this.idDiligenciaConfig).subscribe(response => {
            this.organizacionOption = response;
            if (response.length === 1) {
                const option: EvkOption = {
                    value: idUnidad,
                    label: unidad,
                    disabled: true
                };
                this.haveConfigAsignaciones = false;
                this.getUsuariosByIdOrganizacion(option);
                this.form.controls.unidadDestino.setValue(option);
            }
            this.catalogosCargados.emit(true);
        });
        this.eventHandlerEventInit();
        this.hasRoleTitularMasc();  
    }

    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.usuarioFilterOption$ = filterOptionsv2(this.form,'usuarioDestino', of(this.usuarioOption));
                this.organizacionFilterOption$ = filterOptionsv2(this.form,'unidadDestino', of(this.organizacionOption));
            }
        });
    }

    getUsuariosByIdOrganizacion(option: EvkOption) {
        this.resetChildOptionsFromOrganizacion();
        if (option.value !== null && !this.isTitularMasc) {
            this.catalogoService.getUsuariosByIdUnidadAndRoles(option.value, 'RECEPTOR_TAREA').subscribe(response => {
                this.usuarioOption = response;
                this.usuarioFilterOption$ = filterOptionsv2(this.form,'usuarioDestino', of(this.usuarioOption));
            });
        }
        if (option.value !== null && this.isTitularMasc) {
            this.catalogoService.getUsuariosByIdUnidadAndRoles(option.value, 'FACILITADOR_MASC').subscribe(response => {
                this.usuarioOption = response;
                this.usuarioFilterOption$ = filterOptionsv2(this.form,'usuarioDestino', of(this.usuarioOption));
            });
        }
    }

    cleanValuesUsuarioAsignacion(event$: any) {
        if (event$.target.value === '') {
            this.resetChildOptionsFromOrganizacion();
        }
    }

    resetChildOptionsFromOrganizacion() {
        this.usuarioOption = [];
        this.form.controls.usuarioDestino.setValue('');
    }

    hasRoleTitularMasc(){
        console.log("REVISAR ESTA IMPLEMENTACION DE ROLES");
        this.roles = localStorage.getItem('roles').split(',');
        if (this.roles.includes('TITULAR_DE_UNIDAD_MASC')){
            this.isTitularMasc = true;
        }else{
            this.isTitularMasc = false;
        }
    }
    
}
